module.exports = __webpack_public_path__ + "img/inter-v3-latin-ext_latin-700.7d2aadf.svg";